import { mdToHtml } from "@knowt/editor/md/parsing/parse";
import { EditorState } from "@knowt/editor/pm/state";

const stripListWrapper = (html: string) => {
    html = html.replace(/^\s*<(ul|ol)[^>]*>/i, "");
    html = html.replace(/<\/(ul|ol)>\s*$/i, "");
    return decodeHTMLEntities(html.trim());
};

const stripLi = (html: string) => {
    html = html.replace(/^\s*<li[^>]*>/i, "");
    html = html.replace(/<\/li>\s*$/i, "");
    return decodeHTMLEntities(html);
};

const decodeHTMLEntities = (html: string) => {
    const entities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
        "&#39;": "'",
    };

    return html.replace(/&amp;|&lt;|&gt;|&quot;|&apos;|&#39;/g, match => entities[match]);
};

const stripP = (html: string, prefix = "") => {
    html = html.replace(/^\s*<p[^>]*>/i, "");
    html = html.replace(/<\/p>\s*$/i, "");

    return prefix + decodeHTMLEntities(html);
};

export const parsedGhostTextHtml = ({ editor, suggestion, state }) => {
    const doesSuggestionStartWithSpace = suggestion.startsWith(" ");
    const prefix = doesSuggestionStartWithSpace ? " " : "";

    const html = mdToHtml(suggestion, "note");

    const isInList = editor.isActive("listItem");
    const isInBulletList = editor.isActive("bulletList");
    const isInOrderedList = editor.isActive("orderedList");

    // if this is just meant for normal text, just get the stripped string
    // <p>result</p> -> result
    if (!isInList && !isInBulletList && !isInOrderedList) {
        return stripP(html, prefix).trimEnd();
    }

    const htmlContainsList = html.includes("<ul>") || html.includes("<ol>");
    const nodeIsEmpty = !state.selection.$from.parent.textContent;
    if (isInList) {
        // if on first empty bullet list and result is list then just get the list
        // <ol><li>result</li></ol> -> result
        if (nodeIsEmpty) {
            return stripP(stripLi(stripListWrapper(html)));
        }

        // if we are in list and meant the result for new list item then get the list item only
        // <ol><li>text text result</li></ol> -> <li>result</li>
        if (htmlContainsList) {
            return stripListWrapper(html);
        }

        return stripP(stripListWrapper(html));
    }

    return "<p>" + stripP(html, prefix) + "</p>";
};

/** prevent double spaces (text __ another text) on accept suggestion */
export const getSuggestionTrimDoubleSpaces = ({ state, suggestion }: { state: EditorState; suggestion: string }) => {
    let newSuggestion = suggestion?.trimEnd() || "";
    const nodeText = state.selection.$from.parent.textContent;
    if (nodeText.endsWith(" ") && newSuggestion.startsWith(" ")) {
        newSuggestion = newSuggestion.trimStart();
    }

    return newSuggestion;
};
